import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocationDetailsService {
  public location :{ id :number; [key :string] :any };

  private readonly _location = new BehaviorSubject<any>(<any>{});
  public location$ = this._location.asObservable();

  get() {
    return this.location;
  }

  set(location :any) {
    this.location = location;
    this._location.next(location);
  }
}
